const getPersianToday = () => {
    const parts = new Intl.DateTimeFormat('en-US-u-ca-persian', {
        year: 'numeric', month: 'numeric', day: 'numeric',
    }).formatToParts(new Date());
    return Object.fromEntries(parts.filter((part) => part.type !== 'literal').map((part) => [part.type, Number(part.value)]));
};

export const getMemberAge = (birthDay) => {
    if (!birthDay) return null;

    const match = String(birthDay).match(/^(\d{1,4})[\/-](\d{1,2})[\/-](\d{1,2})/);
    if (!match) return null;

    const [, yearText, monthText, dayText] = match;
    const birthYear = Number(yearText);
    const birthMonth = Number(monthText);
    const birthDate = Number(dayText);
    if (!birthYear || birthMonth < 1 || birthMonth > 12 || birthDate < 1 || birthDate > 31) return null;

    const today = getPersianToday();
    const currentYear = birthYear < 1700 ? today.year : new Date().getFullYear();
    const currentMonth = birthYear < 1700 ? today.month : new Date().getMonth() + 1;
    const currentDay = birthYear < 1700 ? today.day : new Date().getDate();
    const age = currentYear - birthYear - (currentMonth < birthMonth || (currentMonth === birthMonth && currentDay < birthDate) ? 1 : 0);

    return age >= 0 ? age : null;
};
